var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',_vm._b({attrs:{"type":_vm.type}},'b-tag',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }